export default function ppnFilter(ppn: boolean): string {
  return ppn ? "PPN" : "Non PPN";
}
